var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 4.21301C16.3672 3.929 15.9087 3.929 15.6259 4.21301C15.3431 4.49703 15.3431 4.95751 15.6259 5.24153L18.5276 8.15584H3.72416C3.32423 8.15584 3.00002 8.48145 3.00002 8.88312C3.00002 9.28478 3.32423 9.61039 3.72416 9.61039H20.2758C20.5687 9.61039 20.8328 9.4332 20.9449 9.16143C21.0569 8.88967 20.995 8.57686 20.7879 8.36886L16.65 4.21301Z",
    fill: "#3545DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35004 19.787C7.63283 20.071 8.09133 20.071 8.37412 19.787C8.65691 19.503 8.65691 19.0425 8.37412 18.7585L5.47238 15.8442H20.2758C20.6758 15.8442 21 15.5185 21 15.1169C21 14.7152 20.6758 14.3896 20.2758 14.3896H3.72416C3.43127 14.3896 3.16723 14.5668 3.05514 14.8386C2.94306 15.1103 3.00501 15.4231 3.21212 15.6311L7.35004 19.787Z",
    fill: "#3545DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.dbe94e9484479161b41f1838b6c86294.svg";
export { ForwardRef as ReactComponent };